import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import StatusBadge from "./StatusBadge";
import SoldTape from "./SoldTape";
import { ArrowUpRight } from "lucide-react";

export default function StrainCard({ strain, index = 0 }) {
  const dimmed = strain.status === "SOLD_OUT";
  const num = String(index + 1).padStart(2, "0");
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay: (index % 3) * 0.08, ease: [0.16, 1, 0.3, 1] }}
    >
      <Link
        to={`/strains/${strain.slug}`}
        data-testid={`strain-card-${strain.slug}`}
        className={`group block ${dimmed ? "opacity-40" : ""}`}
      >
        <div className="relative aspect-[4/5] overflow-hidden bg-yaza-surface2">
          {strain.images?.[0] && (
            <img
              src={strain.images[0]}
              alt={strain.name}
              loading="lazy"
              className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
            />
          )}
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
          {dimmed && <SoldTape testid={`sold-tape-${strain.slug}`} />}
          <div className="absolute left-3 top-3">
            <StatusBadge status={strain.status} />
          </div>
          <div className="absolute bottom-3 left-3 bg-yaza-accent px-2 py-0.5 font-mono text-xs font-bold tracking-widest text-black">
            {num}
          </div>
          <div className="absolute right-3 top-3 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
            <ArrowUpRight className="text-yaza-accent" />
          </div>
        </div>
        <div className="mt-3 flex items-start justify-between gap-2">
          <div>
            <h3 className="font-display text-2xl leading-none tracking-wide">{strain.name}</h3>
            <p className="mt-1 text-xs uppercase tracking-widest text-yaza-dim">{strain.type}</p>
          </div>
          {strain.lineage && (
            <p className="max-w-[45%] text-right text-[11px] text-neutral-500">{strain.lineage}</p>
          )}
        </div>
      </Link>
    </motion.div>
  );
}
